import axios from '../utils/aioxs'
import { domainid } from '@/utils/utils'
import API from './dataset'
import Jons from 'utils/dataset.json'

const getEnvParams = params => {
  let env = process.env.NODE_ENV
  if (env == 'base') {
    params.data.query = Jons[params.data.application][params.data.datasource][params.data.name]
  }
  return params
}

// 获取订单列表
export function getOrderList(params) {
  let ems = process.env.VUE_APP_LINKU_EMS
  return axios(
    getEnvParams({
      method: 'post',
      url: `/datapool/mysql`,
      data: {
        application: 'linku_ems',
        name: 'query_charge_bills',
        datasource: 'evcs_backend',
        param: {
          domain_id: domainid(),
          ...params,
          table: ems,
        },
      },
    }),
  )
}

// 订单终止
export function stopOrderApi(data, iot_id) {
  return axios({
    method: 'post',
    url: `/operation/${domainid()}/evcs/${iot_id}/stop`,
    data,
  })
}

// 获取用户列表
export function getUserList(params) {
  return axios(
    getEnvParams({
      method: 'post',
      url: `/datapool/mysql`,
      data: {
        application: 'linku_ems',
        name: 'query_customer_list',
        datasource: 'evcs_backend',
        param: {
          ...params,
          domain_id: domainid(),
        },
      },
    }),
  )
}
// 获取用户权限列表
export function getUserRoleList(params) {
  return axios(
    getEnvParams({
      method: 'post',
      url: `/datapool/mysql`,
      data: {
        application: 'linku_ems',
        name: 'query_customer_roles',
        datasource: 'evcs_backend',
        param: {
          ...params,
          domain_id: domainid(),
        },
      },
    }),
  )
}
// 修改用户信息
export function updateUser(data) {
  return axios({
    method: 'put',
    url: `/datapool/mysql/${domainid()}/evcs_backend/customer`,
    data: data,
  })
}
// 修改用户权限信息
export function updateUserRole(data) {
  return axios({
    method: 'put',
    url: `/datapool/mysql/${domainid()}/evcs_backend/customer_access`,
    data: data,
  })
}

// 获取消费记录
export function getRecordList(params) {
  return axios(
    getEnvParams({
      method: 'post',
      url: `/datapool/mysql`,
      data: {
        application: 'linku_ems',
        name: 'query_customer_wallet_record',
        datasource: 'evcs_backend',
        param: {
          domain_id: domainid(),
          ...params,
        },
      },
    }),
  )
}

// 获取最后一次操作日志
export async function getLatestOperationLog(params) {
  const param = {
    domain_id: params.domainid || domainid(),
    ...params,
  }
  return API.dataset(param, {
    application: 'linku_ems',
    datasource: 'ems_backend',
    name: 'operation_latest_log',
  })
}

// 查询操作日志
export async function getOperationLog(params) {
  const param = {
    domain_id: domainid(),
    // domain_id: 'ee5ed02981484438b457bcf0f299a139',
    ...params,
  }
  return API.dataset(param, {
    application: 'linku_ems',
    datasource: 'ems_backend',
    name: 'operation_log',
  })
}

export async function submitOperationLog({ type, data, headersParams = undefined }) {
  let headers = {}
  if (headersParams !== undefined) {
    headers = {
      CheckRule: encodeURIComponent(JSON.stringify(headersParams)),
    }
  } else {
    headers = {}
  }

  return axios({
    method: 'post',
    url: `operation/${domainid()}/controller/${type}/${data.iot_id}/parameter`,
    data,
    headers,
  })
}

export async function setTimeEngineParamter(params, data) {
  return axios({
    method: 'post',
    url: `/operation/${domainid()}/controller/time_engine/parameter`,
    data,
    params,
  })
}
export async function getTimeEngineParamter(params) {
  return axios({
    method: 'get',
    url: `/operation/${domainid()}/controller/time_engine/parameter`,
    params,
  })
}

// 获取订单列表
export function getEnergyAndFeeByUsers(params) {
  return axios(
    getEnvParams({
      method: 'post',
      url: `/datapool/mysql`,
      data: {
        application: 'linku_ems',
        datasource: 'evcs_backend',
        name: 'query_charge_bills_by_users',
        param: {
          domain_id: domainid(),
          ...params,
        },
      },
    }),
  )
}
export function getEnergyAndFeeByStation(params) {
  return axios(
    getEnvParams({
      method: 'post',
      url: `/datapool/mysql`,
      data: {
        application: 'linku_ems',
        datasource: 'evcs_backend',
        name: 'query_charge_bills_by_station',
        param: {
          domain_id: domainid(),
          ...params,
        },
      },
    }),
  )
}
